import { isAbsolute, join } from 'path'

function normalizeTaskFileStem(taskId: string): string {
  const trimmed = String(taskId).trim().replace(/\.json$/i, '')
  if (/^task-\d+$/.test(trimmed)) return trimmed
  if (/^\d+$/.test(trimmed)) return `task-${trimmed}`
  return trimmed
}

export const TeamPaths = {
  root: (teamName: string) =>
    `.harness/state/team/${teamName}`,

  config: (teamName: string) =>
    `.harness/state/team/${teamName}/config.json`,

  tasks: (teamName: string) =>
    `.harness/state/team/${teamName}/tasks`,

  taskFile: (teamName: string, taskId: string) =>
    `.harness/state/team/${teamName}/tasks/${normalizeTaskFileStem(taskId)}.json`,

  workers: (teamName: string) =>
    `.harness/state/team/${teamName}/workers`,

  workerDir: (teamName: string, workerName: string) =>
    `.harness/state/team/${teamName}/workers/${workerName}`,

  heartbeat: (teamName: string, workerName: string) =>
    `.harness/state/team/${teamName}/workers/${workerName}/heartbeat.json`,

  inbox: (teamName: string, workerName: string) =>
    `.harness/state/team/${teamName}/workers/${workerName}/inbox.md`,

  outbox: (teamName: string, workerName: string) =>
    `.harness/state/team/${teamName}/workers/${workerName}/outbox.jsonl`,
} as const

export function absPath(cwd: string, relativePath: string): string {
  return isAbsolute(relativePath) ? relativePath : join(cwd, relativePath)
}

export function teamStateRoot(cwd: string, teamName: string): string {
  return join(cwd, TeamPaths.root(teamName))
}
